import http, { expandURI } from '@/utils/ajax'
import { SPECFUNC_TTY_ACCT_INIT_LOADING, SPECFUNC_TTY_ACCT_INIT_SUCCESS, SPECFUNC_TTY_ACCT_INIT_FAIL, UPLOAD_TTY_PREM_COMM_INIT_LOADING, UPLOAD_TTY_PREM_COMM_INIT_SUCCESS, UPLOAD_TTY_PREM_COMM_INIT_FAIL, UPLOAD_TTY_CLM_PAYM_RES_INIT_LOADING, UPLOAD_TTY_CLM_PAYM_RES_INIT_SUCCESS, UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL, GEN_QUART_STMT_INIT_LOADING, GEN_QUART_STMT_INIT_SUCCESS, GEN_QUART_STMT_INIT_FAIL, BATCH_RELEASE_MTHLY_TTY_STMT_INIT_LOADING, BATCH_RELEASE_MTHLY_TTY_STMT_INIT_SUCCESS, BATCH_RELEASE_MTHLY_TTY_STMT_INIT_FAIL, BATCH_RELEASE_QRTLY_TTY_STMT_INIT_LOADING, BATCH_RELEASE_QRTLY_TTY_STMT_INIT_SUCCESS, BATCH_RELEASE_QRTLY_TTY_STMT_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async specFuncTtyAcctInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.specFuncTtyAcctManagement
    if (apiUrl) {
      commit(SPECFUNC_TTY_ACCT_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(SPECFUNC_TTY_ACCT_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(SPECFUNC_TTY_ACCT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(SPECFUNC_TTY_ACCT_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async uploadTreatyPremCommInit({ commit, state }) {
    const apiUrl = state.menu.uploadTreatyPremComm
    if (apiUrl) {
      commit(UPLOAD_TTY_PREM_COMM_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(UPLOAD_TTY_PREM_COMM_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(UPLOAD_TTY_PREM_COMM_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(UPLOAD_TTY_PREM_COMM_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async uploadTreatyClmPaymResInit({ commit, state }) {
    const apiUrl = state.menu.uploadTreatyClmPaymRes
    if (apiUrl) {
      commit(UPLOAD_TTY_CLM_PAYM_RES_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(UPLOAD_TTY_CLM_PAYM_RES_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async genQuartStmtInit({ commit, state }) {
    const apiUrl = state.menu.genQuartStmt
    if (apiUrl) {
      commit(GEN_QUART_STMT_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(GEN_QUART_STMT_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(GEN_QUART_STMT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(GEN_QUART_STMT_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async batchRelMthlyTtyStmtInit({ commit, state }) {
    const apiUrl = state.menu.batchRelMthlyTtyStmt
    if (apiUrl) {
      commit(BATCH_RELEASE_MTHLY_TTY_STMT_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(BATCH_RELEASE_MTHLY_TTY_STMT_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(BATCH_RELEASE_MTHLY_TTY_STMT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(BATCH_RELEASE_MTHLY_TTY_STMT_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  },
  async batchRelQrtlyTtyStmtInit({ commit, state }) {
    const apiUrl = state.menu.batchRelQrtlyTtyStmt
    if (apiUrl) {
      commit(BATCH_RELEASE_QRTLY_TTY_STMT_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(BATCH_RELEASE_QRTLY_TTY_STMT_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(BATCH_RELEASE_QRTLY_TTY_STMT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(BATCH_RELEASE_QRTLY_TTY_STMT_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
